import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const d10 = (v) => (v ? `${v.slice(8, 10)}.${v.slice(5, 7)}.${v.slice(0, 4)}` : "—");

export const UnterschriftenVorBeginn = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/dashboard/unterschriften-vor-beginn`).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.anzahl) return null;
  return (
    <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-4" data-testid="dashboard-unterschriften-vor-beginn">
      <p className="flex items-center gap-2 font-medium text-red-800">
        <AlertTriangle size={16} /> {d.anzahl} Teilnehmende starten in den nächsten 3 Tagen ohne vollständige Unterschriften
      </p>
      <ul className="mt-2 space-y-1 text-sm text-red-900">
        {d.teilnehmer.map((t) => (
          <li key={t.teilnehmer_id} data-testid={`dashboard-unterschrift-fehlt-${t.teilnehmer_id}`}>
            <b>{t.name}</b> · Beginn {d10(t.start)} · {t.kurs || "—"} · fehlt: {t.fehlt.join(", ")}
          </li>
        ))}
      </ul>
    </div>
  );
};
